module.exports = __webpack_public_path__ + "static/media/ic_setting_blue.55b60953.svg";